export default __webpack_public_path__ + "static/media/full-screen.c4cc37cc.svg";